import Lottie from "lottie-react";
import styled from "styled-components";

export const StyledAppLottie = styled(Lottie)`
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  &.lottie-account-created {
    svg {
      path:is([fill="rgb(255,255,255)"]) {
        fill: transparent;
      }
    }
  }

  &.lottie-bank-transfer {
    svg {
      path:is([fill="rgb(163,222,255)"]) {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
      path:is([fill="rgb(0,158,226)"]) {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
      path:is([fill="rgb(0,158,227)"]) {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
      path:is([stroke="rgb(236,236,236)"]) {
        stroke: ${({ theme }) => theme.palette.borderColor.main};
      }
    }
  }

  &.lottie-update {
    width: auto !important;
    svg {
      path:is([fill="rgb(100,218,181)"]) {
        fill: ${({ theme }) => theme.palette.primary.main};
      }
    }
  }
`;
